import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/email-logo.webp'


const _hoisted_1 = { style: {"background-color":"var(--background-color-dark)"} }
const _hoisted_2 = {
  class: "search-section-background pb-5",
  style: {}
}
const _hoisted_3 = {
  class: "",
  style: {"background-color":"var(--background-color-light)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_section = _resolveComponent("header-section")!
  const _component_logo_carousel = _resolveComponent("logo-carousel")!
  const _component_how_it_works_steps = _resolveComponent("how-it-works-steps")!
  const _component_do_not_assume = _resolveComponent("do-not-assume")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_header_section, { pinHeader: false }),
      _cache[0] || (_cache[0] = _createElementVNode("img", {
        style: {"display":"none"},
        src: _imports_0,
        alt: "email logo"
      }, null, -1)),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "welcome-wrapper container-fluid" }, [
        _createElementVNode("div", { class: "row" }, [
          _createElementVNode("h1", { class: "col-sm-12 col-md-8 offset-md-2 welcome-header text-light" }, " Don't Overpay On Your Prescriptions ")
        ])
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_logo_carousel, { class: "" }),
      _createVNode(_component_how_it_works_steps, {
        class: "py-5",
        style: {"background-color":"var(--background-color-off-light)"}
      }),
      _createVNode(_component_do_not_assume)
    ])
  ]))
}